import { render, staticRenderFns } from "./CRM.vue?vue&type=template&id=adf51610&scoped=true&"
import script from "./CRM.vue?vue&type=script&lang=js&"
export * from "./CRM.vue?vue&type=script&lang=js&"
import style0 from "./CRM.vue?vue&type=style&index=0&id=adf51610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf51610",
  null
  
)

export default component.exports